import _identity from "ramda/es/identity";
import _T from "ramda/es/T";
import _F from "ramda/es/F";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import log from './log';

var lambdaHandler = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$returnEarly = _ref.returnEarly,
      returnEarly = _ref$returnEarly === void 0 ? _F : _ref$returnEarly,
      _ref$logger = _ref.logger,
      logger = _ref$logger === void 0 ? log : _ref$logger,
      _ref$logEvent = _ref.logEvent,
      logEvent = _ref$logEvent === void 0 ? _T : _ref$logEvent,
      _ref$logEventTransfor = _ref.logEventTransform,
      logEventTransform = _ref$logEventTransfor === void 0 ? _identity : _ref$logEventTransfor,
      _ref$validateEvent = _ref.validateEvent,
      validateEvent = _ref$validateEvent === void 0 ? _identity : _ref$validateEvent,
      _ref$logValidEvent = _ref.logValidEvent,
      logValidEvent = _ref$logValidEvent === void 0 ? validateEvent === _identity ? _F : _T : _ref$logValidEvent,
      _ref$logValidEventTra = _ref.logValidEventTransform,
      logValidEventTransform = _ref$logValidEventTra === void 0 ? _identity : _ref$logValidEventTra,
      _ref$logResponse = _ref.logResponse,
      logResponse = _ref$logResponse === void 0 ? _T : _ref$logResponse,
      _ref$logResponseTrans = _ref.logResponseTransform,
      logResponseTransform = _ref$logResponseTrans === void 0 ? _identity : _ref$logResponseTrans,
      _ref$logError = _ref.logError,
      logError = _ref$logError === void 0 ? _T : _ref$logError,
      _ref$logErrorTransfor = _ref.logErrorTransform,
      logErrorTransform = _ref$logErrorTransfor === void 0 ? _identity : _ref$logErrorTransfor,
      _ref$rethrow = _ref.rethrow,
      rethrow = _ref$rethrow === void 0 ? _F : _ref$rethrow,
      _ref$errorTransform = _ref.errorTransform,
      errorTransform = _ref$errorTransform === void 0 ? function (_ref2) {
    var error = _ref2.error;
    return error;
  } : _ref$errorTransform;

  return function (handler) {
    return /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event, context, callback) {
        var validEvent, response;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!returnEarly(event)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", event);

              case 3:
                if (logEvent({
                  event: event
                })) logger('Event', logEventTransform(event));
                _context.next = 6;
                return validateEvent(event);

              case 6:
                validEvent = _context.sent;
                if (logValidEvent({
                  event: event,
                  validEvent: validEvent
                })) logger('Valid event', logValidEventTransform(validEvent));
                _context.next = 10;
                return handler(validEvent, context, callback);

              case 10:
                response = _context.sent;
                if (logResponse({
                  event: event,
                  validEvent: validEvent,
                  response: response
                })) logger('Response', logResponseTransform(response));
                return _context.abrupt("return", response);

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](0);
                // eslint-disable-line unicorn/catch-error-name
                if (logError({
                  event: event,
                  error: _context.t0
                })) logger('Error', logErrorTransform(_context.t0));

                if (!rethrow({
                  event: event,
                  error: _context.t0
                })) {
                  _context.next = 20;
                  break;
                }

                throw errorTransform({
                  event: event,
                  error: _context.t0
                });

              case 20:
                return _context.abrupt("return", errorTransform({
                  event: event,
                  error: _context.t0
                }));

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 15]]);
      }));

      return function () {
        return _ref3.apply(this, arguments);
      };
    }();
  };
};

export default lambdaHandler;